// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__dasUp","sidebarNav":"SideBar_sidebarNav__lE64Z","sidebarLink":"SideBar_sidebarLink__BVW1k"};